import { AccentColorPayload, AppDesign } from "../types/configurationType";
import { CallResult, doApiGet, doApiPatch, doApiPost } from "./Requests";

export const configurationApi = {
  getAppDesignData: (): Promise<CallResult<Partial<AppDesign>>> =>
    doApiGet(`/api/companies/current/customizations`),

  uploadCompanyLogo: (fileContent: string | null): Promise<CallResult<any>> =>
    doApiPost(`/api/companies/current/customizations/companyLogo`, fileContent),

  editAccentColor: (accentColorJSON: AccentColorPayload): Promise<CallResult<any>> =>
    doApiPatch(`/api/companies/current/customizations`, accentColorJSON),
};